import Card from "../../components/Games/Card";
import ViewList from "../../components/Templates/ViewList";
import { useContent } from "../../content/useContent";
import useGamesContainer from "../../containers/Games/useGamesContainer";
const Games = () => {
  const {
    games,
    pageLoading,
    handleSearch,
    searchValue,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useGamesContainer();

  const { games: content } = useContent().pages;

  type IProps = {
    row: any;
  };

  const Row: React.FC<IProps> = ({ row }) => {
    return <Card handleClick={handleClick} row={row} />;
  };

  return (
    <ViewList
      title={content.title}
      multiTitle={content.multi}
      selectRef="name"
      pageLoading={pageLoading}
      searchValue={searchValue}
      handleSearch={handleSearch}
      rowsPerPage={rowsPerPage}
      page={page}
      rows={games}
      handleChangePage={handleChangePage}
      Row={Row}
      addPath={null}
      selected={selected}
      handleDelete={null}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
    />
  );
};

export default Games;
